import Swiper from "swiper";


const trustUsSwiper = new Swiper('.trust-us-swiper', {
  slidesPerView: 2,
  loop: true,
  spaceBetween: 30,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },

  breakpoints: {
    540: {
      slidesPerView: 3
    },
    768: {
      slidesPerView: 4
    },
    992: {
      slidesPerView: 5
    }
  }
})

